import axios from 'axios';

// Конфигурация axios

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});


// Сохраняем текущий API URL в localStorage для отслеживания изменений
const CURRENT_API_URL_KEY = 'current_api_base_url';
const currentApiUrl = process.env.REACT_APP_API_BASE_URL;
const storedApiUrl = localStorage.getItem(CURRENT_API_URL_KEY);

// Если API URL изменился, очищаем кеш и диспатчим событие
if (storedApiUrl && storedApiUrl !== currentApiUrl) {
  // API URL изменился
  // Очищаем кеш данных, связанных с API
  localStorage.removeItem('rebbud_project_autosave'); // Очищаем автосохранение проекта
  // Диспатчим событие для перезагрузки данных
  window.dispatchEvent(new CustomEvent('api-url-changed', { 
    detail: { oldUrl: storedApiUrl, newUrl: currentApiUrl } 
  }));
}

// Сохраняем текущий API URL
localStorage.setItem(CURRENT_API_URL_KEY, currentApiUrl);

// Функция для обновления baseURL (на случай, если нужно обновить динамически)
export const updateBaseURL = (newBaseURL) => {
  const oldBaseURL = axiosInstance.defaults.baseURL;
  axiosInstance.defaults.baseURL = newBaseURL;
  localStorage.setItem(CURRENT_API_URL_KEY, newBaseURL);
  if (oldBaseURL !== newBaseURL) {
    window.dispatchEvent(new CustomEvent('api-url-changed', { 
      detail: { oldUrl: oldBaseURL, newUrl: newBaseURL } 
    }));
  }
};

let accessToken = null;

export const setAuthToken = (token) => {
  accessToken = token;
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
  }
};
 
export const removeAuthToken = () => {
    accessToken = null;
    delete axiosInstance.defaults.headers.common['Authorization'];
};

axiosInstance.interceptors.request.use(
    config => {
        if (accessToken && !config.headers['Authorization']) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // --- ИСПРАВЛЕНИЕ: Добавляем проверку, чтобы не зациклиться на запросе refresh-token ---
    const isRefreshRequest = originalRequest.url === '/api/auth/refresh-token';

    if (error.response && error.response.status === 401 && !originalRequest._retry && !isRefreshRequest) {
      originalRequest._retry = true;

      try {
        const res = await axiosInstance.get('/api/auth/refresh-token');
        const newAccessToken = res.data.accessToken;
        
        setAuthToken(newAccessToken);
        
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Проверяем, установлен ли флаг rememberMe
        const rememberMe = localStorage.getItem('rememberMe') === 'true';
        
        if (!rememberMe) {
          // Если rememberMe не установлен, выходим как обычно
          removeAuthToken();
          // Диспатчим событие, чтобы AuthContext мог среагировать и разлогинить пользователя
          window.dispatchEvent(new Event('auth-error'));
        }
        // Если rememberMe установлен, не выходим - просто возвращаем ошибку
        // Пользователь останется в системе, токен будет обновлен при следующем успешном запросе
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
